export const redColorRange = ['#c6432d', '#f4735e', '#d2513c', '#ed705b']
